import React, { Component } from "react";
import * as Icon from "react-feather";

import "./playbook-build-todo-list.css";

class PlaybookBuildTodoList extends Component {
	render() {
		const { todos, isSending, isBuilding, isPublishing, busyLabels, onChoose } = this.props;
		if (todos.length === 0) return <p className="playbook-build-todo-list__empty tk-card tk-muted">Nothing is waiting on you.</p>;
		const blockingTodos = todos.filter(todo => !todo.isOptional);
		const optionalTodos = todos.filter(todo => todo.isOptional);
		const todoGroups = [
			{ key: "blocking", label: null, todos: blockingTodos },
			{ key: "optional", label: "When you're ready", todos: optionalTodos },
		];
		const filledTodoGroups = todoGroups.filter(group => group.todos.length > 0);

		return (
			<section className="playbook-build-todo-list tk-card">
				{filledTodoGroups.map(group => (
					<div key={group.key} className="playbook-build-todo-list__group">
						{group.label && <div className="playbook-build-todo-list__label tk-muted">{group.label}</div>}
						<ul className="playbook-build-todo-list__items">
							{group.todos.map(todo => {
								const isBuildBusy = todo.action === "build" && isBuilding;
								const isPublishBusy = todo.action === "publish" && isPublishing;
								const isBuildWaitingOnTheGuide = todo.action === "build" && isSending;
								const isReplyWaiting = todo.action === "reply" && (isSending || isBuilding);
								const isLineBusy = isBuildBusy || isPublishBusy || isBuildWaitingOnTheGuide || isReplyWaiting;
								let lineText = todo.text;
								if (isBuildBusy) lineText = busyLabels.build;
								if (isPublishBusy) lineText = busyLabels.publish;
								return (
									<li key={todo.key} className="playbook-build-todo-list__item">
										{todo.tab || todo.action ? (
											<button type="button" className="playbook-build-todo-list__line" onClick={() => onChoose({ todo })} disabled={isLineBusy}>
												<span className="playbook-build-todo-list__text">{lineText}</span>
												<Icon.ChevronRight size={14} className="playbook-build-todo-list__chevron" />
											</button>
										) : (
											<div className="playbook-build-todo-list__line playbook-build-todo-list__line--static">
												<span className="playbook-build-todo-list__text">{lineText}</span>
											</div>
										)}
									</li>
								);
							})}
						</ul>
					</div>
				))}
			</section>
		);
	}
}

export default PlaybookBuildTodoList;
